import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';

export const forceLogoutUserThunk = createAdminAsyncThunk<
  undefined,
  { id: string }
>(
  'organizationUsers/forceLogout',
  async({ id }, { extra: { usersService } }) => {
    await usersService.forceLogoutUser(id);
    return undefined;
  }
);
